import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import personPageQuery from "./person.graphql";
import useNodeQuery from "@default/hooks/use-node-query";
import NodeWrapper from "@default/nodes/shared-components/node-wrapper";
import PagerFullPage from "@default/js/general-components/pager-full-page";
import ContentBase from "@default/general-components/content-base/content-base";
import OpenGraphMeta from "@default/js/general-components/seo/open-graph-meta";
import { stripHtml } from "@default/js/general-components/seo/utils";
import { self } from "@default/js/config";

const Person = () => {
  const pagerConfig = useSelector(
    (reduxStore) => reduxStore.appStore.pagerFullPages
  );
  const pagerFullPageContextId = useSelector(
    (reduxStore) => reduxStore.appStore.pagerFullPageContextId
  );

  const { entity, loading, error } = useNodeQuery(personPageQuery);
  const { pathname } = useLocation();

  // Add person-infos per default.
  const modules = {
    list: [
      {
        entity: {
          entityBundle: "person_information",
        },
      },
      ...(entity?.fieldModules?.list || []),
    ],
  };

  return (
    <NodeWrapper entity={entity} loading={loading} error={error}>
      {entity && (
        <OpenGraphMeta
          title={entity.title || entity.label}
          type="profile"
          url={self + pathname}
          description={stripHtml(entity.fieldText)}
          image={entity.fieldImageRawField?.first?.entity?.fieldMediaImage?.style?.url
            ? { url: entity.fieldImageRawField.first.entity.fieldMediaImage.style.url, alt: entity.fieldImageRawField.first.entity.fieldMediaImage.alt }
            : undefined}
        />
      )}
      <ContentBase content={modules.list} nodeContent={entity} />

      {pagerFullPageContextId &&
        pagerConfig.filter((config) => config.id === pagerFullPageContextId)
          .length > 0 && (
          <PagerFullPage
            config={
              pagerConfig.filter(
                (config) => config.id === pagerFullPageContextId
              )[0]
            }
            currentId={entity.entityId}
          />
        )}
    </NodeWrapper>
  );
};

Person.propTypes = {};

export default Person;
